module.exports = __webpack_public_path__ + "static/img/2_9_1.0575a6a6.jpg";